export default __webpack_public_path__ + "cca4eb25059d890139f6ed9e397acc3e.png";